export default class DataReportBlock<T> {
  data: T[];
  constructor(obj?: DataReportBlock<T>) {
    this.data = [...(obj?.data || [])];
  }
}
